/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateSetupSessionMutationVariables = {|
  priceId: string,
  currency: string,
  unit_amount: number,
  interval: string,
  trial?: ?boolean,
|};
export type CreateSetupSessionMutationResponse = {|
  +createSetupSession: ?{|
    +setupSession: ?{|
      +session_id: ?string
    |}
  |}
|};
export type CreateSetupSessionMutation = {|
  variables: CreateSetupSessionMutationVariables,
  response: CreateSetupSessionMutationResponse,
|};
*/


/*
mutation CreateSetupSessionMutation(
  $priceId: String!
  $currency: String!
  $unit_amount: Int!
  $interval: String!
  $trial: Boolean
) {
  createSetupSession(priceId: $priceId, currency: $currency, unitAmount: $unit_amount, interval: $interval, trial: $trial) {
    setupSession {
      session_id
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currency"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "interval"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trial"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unit_amount"
},
v5 = [
  {
    "kind": "Variable",
    "name": "currency",
    "variableName": "currency"
  },
  {
    "kind": "Variable",
    "name": "interval",
    "variableName": "interval"
  },
  {
    "kind": "Variable",
    "name": "priceId",
    "variableName": "priceId"
  },
  {
    "kind": "Variable",
    "name": "trial",
    "variableName": "trial"
  },
  {
    "kind": "Variable",
    "name": "unitAmount",
    "variableName": "unit_amount"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "session_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSetupSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "CreateSetupSession",
        "kind": "LinkedField",
        "name": "createSetupSession",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeSessionNode",
            "kind": "LinkedField",
            "name": "setupSession",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateSetupSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "CreateSetupSession",
        "kind": "LinkedField",
        "name": "createSetupSession",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeSessionNode",
            "kind": "LinkedField",
            "name": "setupSession",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac1aa1a0652290786fbca1143ec435cf",
    "id": null,
    "metadata": {},
    "name": "CreateSetupSessionMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSetupSessionMutation(\n  $priceId: String!\n  $currency: String!\n  $unit_amount: Int!\n  $interval: String!\n  $trial: Boolean\n) {\n  createSetupSession(priceId: $priceId, currency: $currency, unitAmount: $unit_amount, interval: $interval, trial: $trial) {\n    setupSession {\n      session_id\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b892ad985bedc97c5cc8adb196ff3b14';

module.exports = node;
